import React from 'react'
import Helpers from '../../../helpers/shared.helper';
import FieldValidity from '../../../services/fieldValidity.service';

const SharedPhoneKeyPress = ({ placeholder="", name="phone", id="phone", classname="storefront-phone-field", phone,updateContactField = () => {} }) => {
    const checkContactField = (val) => {
        let validationData = Helpers.commonPhoneValidateChecker(val, phone?.validation);
        let phoneObj = {
            value: val,
            valid: validationData.valid,
            touched: true,
            error: validationData.errorType
        }
        updateContactField(phoneObj)
    }

    return (
        <>
            <input
                type="tel"
                className={
                    `${classname} ` +
                    (!phone.touched || (phone.touched && phone.valid)
                        ? "valid"
                        : "invalid") +
                    (phone.value ? " filled" : "")
                }
                name={name}
                id={id}
                value={phone.value}
                onChange={event => {
                    if (FieldValidity.inputDigits(event, phone.validation.maxLengthValue)) {
                        checkContactField(event.target.value)
                    }
                }}
                placeholder={placeholder}
            />
        </>
    );
};

export default SharedPhoneKeyPress;